/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RequestItem } from './RequestItem';
import {
    RequestItemFromJSON,
    RequestItemFromJSONTyped,
    RequestItemToJSON,
    RequestItemToJSONTyped,
} from './RequestItem';

/**
 * 
 * @export
 * @interface ResponseSuccess
 */
export interface ResponseSuccess {
    /**
     * 
     * @type {Array<RequestItem>}
     * @memberof ResponseSuccess
     */
    items?: Array<RequestItem>;
    /**
     * 
     * @type {number}
     * @memberof ResponseSuccess
     */
    userId?: number;
}

/**
 * Check if a given object implements the ResponseSuccess interface.
 */
export function instanceOfResponseSuccess(value: object): value is ResponseSuccess {
    return true;
}

export function ResponseSuccessFromJSON(json: any): ResponseSuccess {
    return ResponseSuccessFromJSONTyped(json, false);
}

export function ResponseSuccessFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseSuccess {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(RequestItemFromJSON)),
        'userId': json['user_id'] == null ? undefined : json['user_id'],
    };
}

export function ResponseSuccessToJSON(json: any): ResponseSuccess {
    return ResponseSuccessToJSONTyped(json, false);
}

export function ResponseSuccessToJSONTyped(value?: ResponseSuccess | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(RequestItemToJSON)),
        'user_id': value['userId'],
    };
}

